export default __webpack_public_path__ + "static/2-4a12530970a92a209560b41c10da15bc.png";